import { lazy } from "react";

const FormCetak = lazy(() => import("./administrasi/FormCetak"));
const TambahSuratDomisili = lazy(() =>
  import("./administrasi/domisili/Tambah")
);
const TambahSuratIzinPesta = lazy(() =>
  import("./administrasi/izinpesta/Tambah")
);
const TambahSuratDudaJanda = lazy(() =>
  import("./administrasi/dudajanda/Tambah")
);
const TambahSuratSKCK = lazy(() => import("./administrasi/skck/Tambah"));
const TambahSuratKehilangan = lazy(() =>
  import("./administrasi/kehilangan/Tambah")
);
const TambahSuratKematian = lazy(() =>
  import("./administrasi/kematian/Tambah")
);
const TambahSuratRapid = lazy(() => import("./administrasi/rapidtest/Tambah"));
const TambahIzinKeramaian = lazy(() =>
  import("./administrasi/izinkeramaian/Tambah")
);
const TambahSuratKetPisah = lazy(() =>
  import("./administrasi/ket_pisah/Tambah")
);
const TambahSuratKetUsaha = lazy(() =>
  import("./administrasi/ket_usaha/Tambah")
);
const TambahSuratKld = lazy(() => import("./administrasi/kld/Tambah"));
const TambahSuratPenguburan = lazy(() =>
  import("./administrasi/penguburan/Tambah")
);
const TambahSuratSKTM = lazy(() => import("./administrasi/sktm/Tambah"));
const TambahSuratBelumMenikah = lazy(() =>
  import("./administrasi/belummenikah/Tambah")
);
const TambahSuratKetPenduduk = lazy(() =>
  import("./administrasi/ket_penduduk/Tambah")
);
const TambahSuratKtt = lazy(() =>
  import("./administrasi/ket_tempattinggal/Tambah")
);
const TambahSuratKetKelahiran = lazy(() =>
  import("./administrasi/kelahiran/Tambah")
);
const TambahSuratKetHakMilik = lazy(() => import("./administrasi/shm/Tambah"));
const TambahSuratSKAW = lazy(() => import("./administrasi/skaw/Tambah"));
const TambahPerekaman = lazy(() => import("./administrasi/perekaman/Tambah"));
const TambahBedaNama = lazy(() => import("./administrasi/bedanama/Tambah"));
const TambahSKTMKeluarga = lazy(() =>
  import("./administrasi/sktm-keluarga/Tambah")
);
const TambahNDS = lazy(() => import("./administrasi/nds/Tambah"));
const TambahREG = lazy(() => import("./administrasi/kaw_nontunggal/Tambah"));
const TambahBukuNikah = lazy(() => import("./administrasi/bukunikah/Tambah"));
const TambahBiayaPemakaman = lazy(() =>
  import("./administrasi/biayapemakaman/Tambah")
);
const TambahBagiWarisan = lazy(() =>
  import("./administrasi/bagi_warisan/Tambah")
);
export {
  FormCetak,
  TambahSuratDomisili,
  TambahSuratIzinPesta,
  TambahSuratDudaJanda,
  TambahSuratSKCK,
  TambahSuratKehilangan,
  TambahSuratKematian,
  TambahSuratRapid,
  TambahIzinKeramaian,
  TambahSuratKetPisah,
  TambahSuratKetUsaha,
  TambahSuratKld,
  TambahSuratPenguburan,
  TambahSuratSKTM,
  TambahSuratBelumMenikah,
  TambahSuratKetPenduduk,
  TambahSuratKtt,
  TambahSuratKetKelahiran,
  TambahSuratKetHakMilik,
  TambahSuratSKAW,
  TambahPerekaman,
  TambahBedaNama,
  TambahSKTMKeluarga,
  TambahNDS,
  TambahREG,
  TambahBukuNikah,
  TambahBiayaPemakaman,
  TambahBagiWarisan,
};
